export const GATEWAY_ID_TO_NAME_MAPPING = {
  1: "stripe",
  2: "primer",
  3: "payoneer",
  4: "razorpay",
  5: "proforma",
  6: "stripe_wire",
};

export const PAYMENT_STATUS_NAME_TO_CODE = {
  success: 7,
  pending: 1,
  failed: 5,
};
